import React, { useEffect } from "react";

import MiniGlobeItem from "./miniGlobeItem";

const MiniGlobe = (props) => {
  useEffect(() => {
    document.querySelectorAll(".mini-globe-ring").forEach((ciclegraph) => {
      let circles = ciclegraph.querySelectorAll(".mini-satellite-outer-ring");
      let angle = 360 - 90,
        dangle = 360 / circles.length;
      angle -= dangle;
      for (let i = 0; i < circles.length; ++i) {
        let circle = circles[i];
        angle += dangle;
        circle.style.transform = `rotate(${angle}deg) translate(${ciclegraph.clientWidth / 2
          }px) rotate(-${angle}deg)`;
      }
    });
  }, []);

  const openLerarningLink = (item) => {
    props.openLerarningLink(item);
  };

  return (
    <>
      {props.item &&
        props.item
          .sort((a, b) => (a.sequence > b.sequence ? 1 : -1))
          .map((linkData, index) => {
            return <MiniGlobeItem key={`zxvdt${index}`} linkData={linkData} openLerarningLink={openLerarningLink} />;
          })}
    </>
  );
};

export default MiniGlobe;
